<template>

	<AppPopup prevent-overlay-dismiss :buttons="[]" ref="popup" :title="''">
		<div class="wrapper-content-popup" id="ended-funnel-popup-wrapper">
			<AppPagination
				ref="pagination"
				:pages="pages"
				:hideHeader="true"
				:hideDots="false"
				:noNavigationButtons="true">
				<template #slide1>
					<div class="slide-content">
						<div class="wrapper-img centered">
							<picture>
								<source type="image/webp" srcset="https://img.qromo.io/img/slider-img-1.webp">
								<img class="slide-image" src="https://img.qromo.io/img/slider-img-1.png" alt="product image">
							</picture>
						</div>
						<h3 class="slide-title pt-20">{{ getString('ended_funnel_popup_title') }}</h3>
						<p class="text-align-center">{{ getString('ended_funnel_popup_text') }}</p>
						<AppButton :text="getString('next')" @click="nextSlide" class="slide-button" />
					</div>
				</template>
				<template #slide2>
					<div class="slide-content">
						<div class="wrapper-img centered">
							<picture>
								<source type="image/webp" srcset="https://img.qromo.io/img/slider-img-2.webp">
								<img class="slide-image" src="https://img.qromo.io/img/slider-img-2.png" alt="product image">
							</picture>
						</div>
						<h3 class="slide-title pt-20">{{ getString('ended_funnel_popup_title_2') }}</h3>
						<p class="text-align-center">{{ getString('ended_funnel_popup_text_2') }}</p>
						<AppButton :text="getString('next')" @click="nextSlide" class="slide-button" />
					</div>
				</template>
				<template #slide3>
					<div class="slide-content">
						<div class="wrapper-img centered">
							<picture>
								<source type="image/webp" srcset="https://img.qromo.io/img/slider-img-3.webp">
								<img class="slide-image" src="https://img.qromo.io/img/slider-img-3.png" alt="product image">
							</picture>
						</div>
						<h3 class="slide-title pt-20">{{ getString('ended_funnel_popup_title_3') }}</h3>
						<p class="text-align-center">{{ getString('ended_funnel_popup_text_3') }}</p>
						<AppButton :text="getString('next')" @click="nextSlide" class="slide-button" />
					</div>
				</template>
				<template #slide4>
					<div class="slide-content">
						<div class="wrapper-img centered">
							<picture>
								<source type="image/webp" srcset="https://img.qromo.io/img/slider-img-4.webp">
								<img class="slide-image" src="https://img.qromo.io/img/slider-img-4.png" alt="product image">
							</picture>
						</div>
						<h3 class="slide-title pt-20">{{ getString('ended_funnel_popup_title_4') }}</h3>
						<p class="text-align-center">{{ getString('ended_funnel_popup_text_4') }}</p>
						<AppButton :text="getString('next')" @click="nextSlide" class="slide-button" />
					</div>
				</template>
				<template #slide5>
					<div class="slide-content">
						<div class="wrapper-img centered">
							<picture>
								<source type="image/webp" srcset="https://img.qromo.io/img/slider-img-5.webp">
								<img class="slide-image" src="https://img.qromo.io/img/slider-img-5.png" alt="product image">
							</picture>
						</div>
						<h3 class="slide-title pt-20">{{ getString('ended_funnel_popup_title_5') }}</h3>
						<p class="text-align-center">{{ getString('ended_funnel_popup_text_5') }}</p>
						<AppButton :text="getString('next')" @click="nextSlide" class="slide-button" />
					</div>
				</template>
				<template #slide6>
					<div class="slide-content">
						<div class="wrapper-img centered">
							<picture>
								<source type="image/webp" srcset="https://img.qromo.io/img/slider-img-6.webp">
								<img class="slide-image" src="https://img.qromo.io/img/slider-img-6.png" alt="product image">
							</picture>
						</div>
						<h3 class="slide-title pt-20">{{ getString('ended_funnel_popup_title_6') }}</h3>
						<p class="text-align-center">{{ getString('ended_funnel_popup_text_6') }}</p>
						<AppButton :text="getString('start')" @click="clickDone" class="slide-button" />
					</div>
				</template>
			</AppPagination>
		</div>
	</AppPopup>

</template>

<script>
import {useLanguageStore, useSvgStore, useScriptStore} from "@/shared/stores";
import {useFunnelStore} from "@/console-new/stores";
import AppPopup from "@/shared/components/AppPopup.vue";
import AppPagination from "@/shared/components/AppPagination.vue";
import AppButton from "@/shared/components/AppButton.vue";

export default {
	name: "EndedFunnelPopup",
	setup() {
		let languageStore = useLanguageStore();
		let svgStore = useSvgStore()
		const funnelStore = useFunnelStore();
		const scriptStore = useScriptStore();
		return {getString: languageStore.getString, funnelStore, scriptStore, getIcon: svgStore.get};
	},
	components: {AppPopup, AppPagination, AppButton},
	props: {
		active: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			currentSlideIndex: 0,
			pages: [
				{id: 1, slotName: 'slide1', title: ''},
				{id: 2, slotName: 'slide2', title: ''},
				{id: 3, slotName: 'slide3', title: ''},
				{id: 4, slotName: 'slide4', title: ''},
				{id: 5, slotName: 'slide5', title: ''},
				{id: 6, slotName: 'slide6', title: ''}
			]
		}
	},
	computed: {
		popupButtons() {
			return [
				{
					text: this.getString('start'),
					callback: this.clickDone
				}
			]
		}
	},
	methods: {
		nextSlide() {
			if(this.currentSlideIndex < this.pages.length - 1) {
				this.currentSlideIndex++;
				this.$refs.pagination?.changeSlide(this.currentSlideIndex);
			}
		},
		clickDone() {
			this.funnelStore.updateBusinessFunnelProgress(this.funnelStore.STEP_COMPLETED)
			this.confettiExplosion();
			this.$refs.popup.toggleStatus(false);
			this.$router.push("/ops/counter");
		},
		singleConfettiExplosion() {
			if(typeof window?.confetti === 'function') {
				window.confetti({
					id: 'ended-funnel-popup',
					particleCount: 100,
					startVelocity: 30,
					spread: 360,
					origin: {
						x: Math.random(),
						y: Math.random() - 0.2
					}
				});
			}
		},
		confettiExplosion() {
			for(let i = 0; i < 3; i++) {
				setTimeout(this.singleConfettiExplosion, i*100 + Math.random()*99);
			}
		}
	},
	mounted() {
		let popup = this.$refs?.popup;
		if(popup && !popup?.active) {
			this.scriptStore.loadScript('confetti', ()=>{});
			popup.toggleStatus(true);
		}
	},
	watch: {
		active(newVal) {
			this.$refs.popup.toggleStatus(!!newVal);
			if(!!newVal) {
				this.scriptStore.loadScript('confetti', ()=>{});
			}
		}
	},
}
</script>

<style lang="scss" scoped>
.wrapper-content-popup {
	width: 100%;
	.slide-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		padding: 0;

		.wrapper-img {
			width: 100%;
			height: 100%;
			max-height: 300px;
			overflow: hidden;
			border-radius: 16px;
			position: relative;
			&:after {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				box-shadow: inset 2px 2px 5px var(--color-box-shadow-4);
				pointer-events: none;
				border-radius: 16px;
			}
			img {
				object-fit: cover;
				height: 100%;
				width: 100%;
			}
		}
	}

	.slide-title {
		font-size: 20px;
		text-align: center;
		color: var(--color-txt);
		margin-bottom: 5px;
	}

	.slide-image {
		max-width: 100%;
		height: auto;
		border-radius: 8px;
		margin-bottom: -5px;
	}

	.slide-button {
		margin-top: 30px;
		min-width: 120px;
	}

	.text-align-center {
		text-align: center;
	}

	.centered {
		display: flex;
		justify-content: center;
		align-items: center;
	}

}
.pt-20 {
	padding-top: 20px;
}
</style>

<style lang="scss">
.popup-container {
	&:has(#ended-funnel-popup-wrapper) .popup-body {
		margin: 0;
	}
	border-radius: 26px !important;
}
</style>
